import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type ReactElement, useEffect } from 'react'

const Page = (): ReactElement => {
  const navigate = useNavigate()

  useEffect(() => {
    localStorage.clear()
    void navigate({ to: '/sign_out' })
  }, [navigate])

  return <div>キャッシュをクリア中...</div>
}
export const Route = createFileRoute('/clear_cache')({
  component: Page,
})
